<template>
  <div class="home_frame">
    <Headers class="header"></Headers>
    <keep-alive>
      <router-view class="main"></router-view>
    </keep-alive>
    <div class="right_box">
        <div class="alibaba" @mouseenter="move_alibaba" @mouseleave="outs_alibaba" @click='to_alibaba'>
        <div style="width: 200px; height: 52px; overflow: hidden">
          <img src="../../../static/img/common/ali.png" alt="" />
          <div>阿里巴巴</div>
        </div>
      </div>
      <div class="checked" @mouseenter="move" @mouseleave="outs" @click='to_xuanxing'>
        <div style="width: 200px; height: 52px; overflow: hidden">
          <img src="../../../static/img/common/shurusousuo.png" alt="" />
          <div>模组选型</div>
        </div>
      </div>
      <div class="phones" @mouseenter="move_phone" @mouseleave="outs_phone">
        <div style="width: 80px; flex-shrink: 0">
          <img src="../../../static/img/common/dianhua.png" alt="" />
          <div>咨询电话</div>
        </div>
        <div
          style="
            width: 170px;
            flex-shrink: 0;
            font-size: 18px;
            line-height: 50px;
          "
        >
          <span style="margin-right: 10px">|</span>181-1260-4960
        </div>
      </div>
      <div class="weixin" @mouseenter="move_weixin" @mouseleave="outs_weixin">
        <div style="width: 80px">
          <img src="../../../static/img/common/qrcode1.png" alt="" />
          <div>微信咨询</div>
        </div>
        <div class="imgCode">
          <img src="../../../static/img/common/kefucode.jpg" alt="" />
        </div>
      </div>
      <div
        class="tops"
        @mouseenter="move_top"
        @mouseleave="outs_top"
        :style="'display:' + displays"
      >
        <div style="width: 80px;transition-duration: 0.5s;" @click="toTop">
          <img src="../../../static/img/common/fanhuidingbu.png" alt="" />
          <div>返回顶部</div>
        </div>
      </div>
    </div>
    <Footers class="footer"></Footers>
  </div>
</template>

<script>
export default {
  name: "home",
  data() {
    return {
      displays: "none",
    };
  },
  components: {
    Headers: () => import("@/components/Module1/headers.vue"),
    Footers: () => import("@/components/Module1/footers.vue"),
  },
  mounted() {
    let that=this;
    window.onscroll = function () {
      if (document.documentElement.scrollTop > 100) {
        that.displays = "block";
      } else {
        that.displays = "none";
      }
    };
  },
  methods: {
    move() {
      $(".checked").eq(0).css({ left: "-20px", width: "100px" });
    },
    outs() {
      $(".checked").eq(0).css({ left: "0", width: "80px" });
    },
     move_alibaba() {
      $(".alibaba").eq(0).css({ left: "-20px", width: "100px" });
    },
    outs_alibaba() {
      $(".alibaba").eq(0).css({ left: "0", width: "80px" });
    },
    move_phone() {
      $(".phones").eq(0).css({ left: "-170px", width: "250px" });
    },
    outs_phone() {
      $(".phones").eq(0).css({ left: "0", width: "80px" });
    },
    move_weixin() {
      $(".weixin").eq(0).css({ left: "-20px", width: "100px" });
    },
    outs_weixin() {
      $(".weixin").eq(0).css({ left: "0", width: "80px" });
    },
    move_top() {
      $(".tops").eq(0).css({ left: "-20px", width: "100px" });
    },
    outs_top() {
      $(".tops").eq(0).css({ left: "0", width: "80px" });
    },
  toTop(){
    $("html,body").animate({scrollTop: 0}, 500); 
  },
  to_alibaba(){
    window.open("https://fastermotion.1688.com","_blank");
  },
  to_xuanxing(){
     var newpls_param = {
        action: "savePls",
        step: 2,
        pls_id: "",
        industry1: "",
        industry1_text: "",
        industry: "",
        industry_text: "",
        axis: "",
        axis_text: "",
        lcm: "",
        lcm_data:"",
        seriesData: "",
        step5data: "",
        step8data: "",
        step6data: "",
        tripL: "",
        seam: "",
        name: "",
        step7data: "",
        output: "",
      };
      this.$store.commit("newpls_param", newpls_param);   
      this.$router.push({name:"LectoType"})
  }
  },
};
</script>
<style lang="scss" scoped>
@import "../../../static/css/common.scss";
.home_frame {
  width: 100%;
  min-height: 100%;
  position: relative;
  padding-bottom: 398px;
  overflow: hidden;
}
* {
  margin: 0;
  padding: 0;
}

.footer {
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 398px;
}
.right_box {
  width: 80px;
  position: fixed;
  right: 0;
  top: 35%;
  z-index: 9999;
  font-size: 14px;
  img {
    width: 30px;
    height: 30px;
    margin-left: 12px;
  }
}
.account {
  width: 0px;
  position: absolute;
  left: 80px;
  top: 10px;
  overflow: hidden;
  white-space: nowrap;
}

.checked,
.alibaba,
.phones,
.weixin,
.tops {
  background: rgba(42, 183, 254, 0.7);
  margin: 0;
  padding: 10px 0px;
  padding-left: 12px;
  margin-bottom: 2px;
  position: relative;
  top: 25%;
  color: white;
  cursor: pointer;
  // overflow: hidden;
  display: flex;
  transition-duration: 0.5s;
}
.imgCode {
  width: 120px;
  height: 120px;
  position: absolute;
  left: -150px;
  top: -25px;
  display: none;
}
.imgCode img {
  width: 100%;
  height: 100%;
}
.weixin:hover .imgCode {
  display: block;
}
</style>




// WEBPACK FOOTER //
// src/components/Home/home.vue